module.exports = __webpack_public_path__ + "img/empty.d7ac019d.png";